import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import t from "./translation";

/*****
 * @SCREENS
Id    Name
1    Brands
2    Models
3    Sterilizers
4    Washers
5    Materials
6    MaterialsType
7    PredefinedPackages
8    Profiles
9    Users
10    ConsultPackage
11    BatchRecord
12    MaterialTracking
13    Packages
14    Charges
15    ManageCycles
16    SterilizedPackages
17    ChargeWashing
18    ManageWashingCycles
19    HygieneMonitoring
*****/

/*****
 * @PERMISSIONS
Id    Name
1    Create
2    Read
3    Update
4    Delete
5    Export
6    Vinculation
7    ToWashing
8    ToSterilize
9    Release
*****/


export const getPermissions = () => {
  const token = localStorage.getItem("permissions");
  if (!token) {
    return null;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch (error) {
    return null;
  }

  if (
    decoded.UserScreenPermissions &&
    typeof decoded.UserScreenPermissions === "string"
  ) {
    try {
      decoded.UserScreenPermissions = JSON.parse(decoded.UserScreenPermissions);
    } catch (error) {
      decoded.UserScreenPermissions = [];
    }
  }

  return decoded.UserScreenPermissions;
};

export const getScreenPermissions = (screen, permission) => {
  let permissions = getPermissions();

  if (!permissions || !Array.isArray(permissions)) {
    toast.error(t("NoPermission") || "You have no permission.");
    return false;
  }

  console.log(permission)

  const hasPermission = permissions.some(
    (perm) => perm.Screen.toUpperCase() === screen.toUpperCase() && perm.Permission.toUpperCase() === permission.toUpperCase()
  );

  if (!hasPermission) {
    toast.error(t("NoPermission") || "You have no permission.");
  }

  return hasPermission;
};
